import type { OtcPopupProduct } from "data-types";
import { useCartContext } from "../../../customHooks/useCart";

export const useOtcQuantityControl = (product: OtcPopupProduct) => {
  const { getCart } = useCartContext();
  const cart = getCart();
  const cartProduct = cart.products.find((p) => p.product_item_id === product.id);
  const quantity = cartProduct?.quantity || 0;
  // One test kit per order unless several kits are allowed (per-country switch, overridden by the A/B arm):
  // with the rule off, any kit already in the cart (this one or another) blocks "+" on every kit.
  const multipleTestLabKitsAllowed = cart.allow_multiple_test_lab_kits === true;
  const testLabInCart = cart.products.some((p) => p.is_test_lab && p.quantity > 0);
  const riskGroupID = cartProduct?.risk_group_id;
  const isRiskGroupBlocked = Boolean(riskGroupID && cart.risk_groups?.some((g) => g.id === riskGroupID && g.status !== "clear"));
  const isIncrementDisabled = (product.is_test_lab && !multipleTestLabKitsAllowed && testLabInCart) || isRiskGroupBlocked;
  return { quantity, isIncrementDisabled };
};
